export const validationMassage = 'Length must be between 20 symbols and no space';

export const validateLocationId = (locationId: string) =>
  /^[a-zA-Z0-9]{20}$/.test(locationId) || validationMassage;
